import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;

class PreferenceService {

    // website
    getAllWebsite() {
        return axios.get(API_URL + 'preferences-website', { headers: authHeader() });
    }
    getDetailWebsite(id) {
        return axios.get(API_URL + 'preferences-website/' + id, { headers: authHeader() });
    }
    updateWebsite(data, id) {
        return axios.patch(API_URL + 'preferences-website/' + id, data, { headers: authHeader() });
    }

    // instagram
    getAllInstagram() {
        return axios.get(API_URL + 'preferences-instagram', { headers: authHeader() });
    }
    getDetailInstagram(id) {
        return axios.get(API_URL + 'preferences-instagram/' + id, { headers: authHeader() });
    }
    updateInstagram(data, id) {
        return axios.patch(API_URL + 'preferences-instagram/' + id, data, { headers: authHeader() });
    }

    // twitter
    getAllTwitter() {
        return axios.get(API_URL + 'preferences-twitter', { headers: authHeader() });
    }
    getDetailTwitter(id) {
        return axios.get(API_URL + 'preferences-twitter/' + id, { headers: authHeader() });
    }
    updateTwitter(data, id) {
        return axios.patch(API_URL + 'preferences-twitter/' + id, data, { headers: authHeader() });
    }

    // telegram
    getAllTelegram() {
        return axios.get(API_URL + 'preferences-telegram', { headers: authHeader() });
    }
    getDetailTelegram(id) {
        return axios.get(API_URL + 'preferences-telegram/' + id, { headers: authHeader() });
    }
    updateTelegram(data, id) {
        return axios.patch(API_URL + 'preferences-telegram/' + id, data, { headers: authHeader() });
    }

    // maps
    getAllMaps() {
        return axios.get(API_URL + 'preferences-maps', { headers: authHeader() });
    }
    getDetailMaps(id) {
        return axios.get(API_URL + 'preferences-maps/' + id, { headers: authHeader() });
    }
    updateMaps(data, id) {
        return axios.patch(API_URL + 'preferences-maps/' + id, data, { headers: authHeader() });
    }

    // elastic
    getAllElastic() {
        return axios.get(API_URL + 'preferences-elastic', { headers: authHeader() });
    }
    getDetailElastic(id) {
        return axios.get(API_URL + 'preferences-elastic/' + id, { headers: authHeader() });
    }
    updateElastic(data, id) {
        return axios.patch(API_URL + 'preferences-elastic/' + id, data, { headers: authHeader() });
    }

    //stopword
    listWord() {
        return axios.get(API_URL + 'stopword', { headers: authHeader() });
    }
    addWord(data) {
        return axios.post(API_URL + 'stopword', data, { headers: authHeader() });
    }
    deleteWord(id) {
        return axios.delete(API_URL + 'stopword/' + id, { headers: authHeader() });
    }

    // elastic
    getRapidApi() {
        return axios.get(API_URL + 'preferences-rapid-api', { headers: authHeader() });
    }
    getRapidApiByID(id) {
        return axios.get(API_URL + 'preferences-rapid-api/' + id, { headers: authHeader() });
    }
    updateRapidApi(data, id) {
        return axios.patch(API_URL + 'preferences-rapid-api/' + id, data, { headers: authHeader() });
    }

}

export default new PreferenceService();
